import { Component, OnInit } from '@angular/core';
import {catchError, finalize, throwError} from "rxjs";
import {HttpService} from "../../../services/http.service";
import {UtilService} from "../../../services/util.service";
import {Router} from "@angular/router";
import {ProtestInfo} from "../../../models/protest";
import {HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-remove-case',
    templateUrl: './remove-case.component.html',
    styleUrls: ['./remove-case.component.scss'],
    standalone: false
})
export class RemoveCaseComponent implements OnInit {
  saving : boolean = false;

  constructor(private httpService : HttpService,
              private util : UtilService,
              private router : Router) { }

  ngOnInit(): void {

  }

  onRemoveCase(value: any) {
    this.httpService.Get<{protestInfo: ProtestInfo}>(`/protestInfo/${value.a_Num}`).pipe(
      catchError(err => {
          return throwError(err);
      }),
    ).subscribe(response => {
      // console.log(response);
      let protest: ProtestInfo = response.protestInfo;
      if (protest != null){
        this.util.displayDialogMessage("Warning!!: Removing Case!",
          "You are about to delete the case " + protest.a_No + ", " + protest.b_No + ", " + protest.company_Name + ".<br><br>" +
          "       Please note that 'A-XXX' and 'A-XXX.1' are not the same. Be sure to enter the exact ANum.<br>" +
          "       Selecting 'Remove' will permanently delete this case and its filings from EPDS. Do you want to proceed?",
          {confirmText:"Remove", cancelBtn:true, confirmButtonColor:"warn", cancelButtonColor:"primary"})
          .subscribe(res => {
            // console.log(res);
            if (res) {
              this.saving = true;
              const headers = new HttpHeaders({'Content-Type':  'application/x-www-form-urlencoded'});
              let formData = new HttpParams()
                .set('aNum', value.a_Num)
                .set('reasonForDeletion', value.reasonForDeletion);

              const options = { ...headers};
              this.httpService.Post<void>('/remove-case?' + formData.toString(),options).pipe(
                finalize(() => this.saving = false),
                catchError(err => {
                  return throwError(err);
                })
              ).subscribe((response) => {
                // console.log(response);
                this.util.displayDialogMessage("Record Successfully Removed", "This record is successfully removed")
              })
            }
          });
      } else {
        this.util.displayDialogMessage("Error", "A# does not exist.");
      }
    });
  }
}



